import axios from 'axios';

// Client for the rebase_server "shared" API (Accept: shared api; version=1).
// Used for catalogs (companies/history, education institutions/degrees/courses,
// languages) and resource_texts (military etc.). The bearer token resolves to
// the current applicant server-side (Shared::V1::BaseController#authenticate_request).
const sharedApi = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://suitupapi.club',
  headers: {
    'Accept': 'shared api; version=1',
    'Content-Type': 'application/json'
  }
});

sharedApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default sharedApi;
